"use strict";

exports.__esModule = true;
exports.UserActionsContext = void 0;
exports.withUserActionsContext = withUserActionsContext;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var UserActionsContext = exports.UserActionsContext = /*#__PURE__*/_react["default"].createContext({
  userActions: [{}]
});
function withUserActionsContext(Component) {
  return function (props) {
    var userActions = _react["default"].useContext(UserActionsContext);
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      userActions: userActions
    }));
  };
}